const env = process.env.REACT_APP_ENV || "dev";

const chargeBeeSite = {
  automation: "",
  beta: "",
  dev: "",
  local: "",
  prod: "",
  test: "",
  uat: "",
};

const localizeAPIKey = {
  automation: "",
  beta: "",
  dev: "",
  local: "",
  prod: "",
  test: "",
  uat: "",
};

const newZeaLandPostAPIUrl = {
  automation: "",
  beta: "",
  dev: "",
  local: "",
  prod: "",
  test: "",
  uat: "",
};

const paasConfig = {
  automation: true,
  beta: true,
  dev: true,
  local: true,
  prod: false,
  test: true,
  uat: false,
};

const shopifyAPIKey = {
  // NOTE: update local key, as per your app
  local: "",
  automation: "",
  beta: "f29202d00091705303bf2eea566c5a00",
  dev: "1bb69dca90a4906816efa1ea1600cac1",
  prod: "5baaa204176fd5136e83a61d93eeeb48",
  test: "b3d6f19f293fefcd1f167c663b00a8bc",
  uat: "b9490f51e9ab32e3e2593d3ae306bf77",
};

const bigCommerceMarketcubeAppId = {
  local: "34545",
  automation: "",
  beta: "",
  dev: "35396",
  prod: "36330",
  test: "35883",
  uat: "36216",
};

const beaconLiveChatAPIKey = {
  local: "",
  automation: "",
  beta: "",
  dev: "",
  prod: "",
  test: "",
  uat: "",
};

const supportEmail = {
  automation: "mc-support@mailinator.com",
  beta: "mc-support@mailinator.com",
  dev: "support@yopmail.com",
  local: "support@yopmail.com",
  prod: "support@marketcube.io",
  test: "mc-support@mailinator.com",
  uat: "mc-support@mailinator.com",
};

const vendorShopifyAPIKey = {
  // NOTE: update local key, as per your app
  local: "",
  automation: "",
  beta: "",
  dev: "",
  prod: "",
  test: "",
  uat: "ß",
};

const vendorWixAPIKey = {
  // NOTE: update local key, as per your app
  local: "",
  automation: "",
  beta: "",
  dev: "",
  prod: "",
  test: "",
  uat: "",
};

const vendorWixShareUrl = {
  // NOTE: update local share url, as per your app
  local: "",
  automation: "",
  beta: "",
  dev: "",
  prod: "",
  test: "",
  uat: "",
};

const config = {
  apiURL: process.env.REACT_APP_GQL_URL || "http://localhost:5000/graphql", // apiURL[env],
  beaconLiveChatAPIKey: beaconLiveChatAPIKey[env],
  brandPageURL: process.env.REACT_APP_BRAND_PAGE_URL || "http://localhost:4000",
  brandPageV2URL: process.env.REACT_APP_BRAND_PAGE_V2_URL || "http://localhost:4001",
  chargeBeeSite: chargeBeeSite[env],
  bigCommerceMarketcubeAppId: bigCommerceMarketcubeAppId[env],
  localizeAPIKey: localizeAPIKey[env],
  muteChatIntegration: true,
  newZeaLandPostAPIUrl: newZeaLandPostAPIUrl[env],
  isPAASEnable: paasConfig[env],
  isProd: env === "prod",
  paasUserId: (process.env.REACT_APP_PAAS_USER_ID && process.env.REACT_APP_PAAS_USER_ID.split(",")) || [],
  rootURL: process.env.REACT_APP_ROOT_URL || "http://localhost:3000", // rootURL[env]
  rotaroUserId: (process.env.REACT_APP_ROTARO_USER_ID && process.env.REACT_APP_ROTARO_USER_ID.split(",")) || [],
  shopifyAPIKey: shopifyAPIKey[env],
  supportEmail: supportEmail[env],
  tinyAPIKey: "33u6rw1t5oqpltv84kk33o0a4yio416nw5ue064rm7c96183",
  vendorShopifyAPIKey: vendorShopifyAPIKey[env],
  vendorWixAPIKey: vendorWixAPIKey[env],
  vendorWixShareUrl: vendorWixShareUrl[env],
  webSocketUrl: process.env.REACT_APP_SOCKET_URL || "wss://localhost:5000/graphql",
};

// Debugging of server not working
// eslint-disable-next-line no-console
// console.log(config, process.env.REACT_APP_ENV, process.env.REACT_APP_ROOT_URL, process.env.REACT_APP_GQL_URL);

export default config;
